import React from "react";

export interface ScenarioListProps {
  children: React.ReactNode;
  className?: string;
}

export const ScenarioList = ({ children, className = "" }: ScenarioListProps) => <div className={`scenario-analysis-list ${className}`}>{children}</div>;

export default ScenarioList;
